import React from 'react'
import SwipeableViews from 'react-swipeable-views'
import { autoPlay, bindKeyboard } from 'react-swipeable-views-utils'
import styled from 'styled-components'
import media from '../../utils/style'
import { Box } from 'rebass'
import Slide from './components/Slide'
import Pagination from './components/Pagination'
import Progress from './components/Progress'

const EnhancedSwipeableViews = autoPlay(bindKeyboard(SwipeableViews))

const ContentFrame = styled(Box)`
  position: relative;
  overflow: hidden;
  padding-bottom: 40px;
  margin-bottom: -40px;

  ${media.MediumScreenUp`
    padding-bottom: 0;
    margin-bottom: 0;
  `}
`

class FeatureHeroCarousel extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      autoplay: true
    }
    this.handleChangeIndex = this.handleChangeIndex.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
    this.handleClickPrevious = this.handleClickPrevious.bind(this)
    this.handleUserInteraction = this.handleUserInteraction.bind(this)
  }

  handleChangeIndex(index) {
    this.setState({ index })
  }

  handleUserInteraction() {
    this.setState({ autoplay: false })
  }

  handleClickNext(e) {
    e.preventDefault()
    this.setState({ index: this.state.index + 1, autoplay: false })
  }

  handleClickPrevious(e) {
    e.preventDefault()
    this.setState({ index: this.state.index - 1, autoplay: false })
  }

  render() {
    const { slides } = this.props
    const { index, autoplay } = this.state
    const slideEls = slides.map((slide, i) => {
      return (
        <div key={slide.title}>
          <Slide
            {...slide}
            onUserInteraction={autoplay && this.handleUserInteraction}
          />
          {slides.length > 1 && (
            <Progress playing={autoplay && index === i} interval={8000} />
          )}
        </div>
      )
    })

    return (
      <ContentFrame mb={[30]} bg="white">
        <EnhancedSwipeableViews
          index={index}
          onChangeIndex={this.handleChangeIndex}
          enableMouseEvents={true}
          autoplay={autoplay}
          interval={8000}
          disableLazyLoading={true}
        >
          {slideEls}
        </EnhancedSwipeableViews>
        {slides.length > 1 && (
          <Pagination
            previousDisabled={index <= 0}
            nextDisabled={index >= slideEls.length - 1}
            onNext={this.handleClickNext}
            onPrevious={this.handleClickPrevious}
          />
        )}
      </ContentFrame>
    )
  }
}

export default FeatureHeroCarousel
